import { getStorage, StorageType } from '@web/data/storage/storage.provider';
import { QuizB2BData } from './quiz-typeform.model';

const QUIZTYPEFORM_KEY = 'UserQuizTypeform';

class QuizTypeformDataSource {
  private sessionStorage = getStorage(StorageType.Local);

  get quizTypeform(): Partial<QuizB2BData> {
    const QuizTypeformString = this.sessionStorage.get(QUIZTYPEFORM_KEY);
    return QuizTypeformString ? (JSON.parse(QuizTypeformString) as QuizB2BData) : {};
  }

  set quizTypeform(value: Partial<QuizB2BData>) {
    this.sessionStorage.put(QUIZTYPEFORM_KEY, JSON.stringify(value));
  }
}

export default new QuizTypeformDataSource();
